import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { useApplication } from 'src/context/ApplicationContext';
import { FormStrucItem } from 'src/lib/types/types';
import { AbschlussSeiteHochladeFeldBox } from 'src/pages/private/online-antrag/antrag-components/AbschlussSeiteBox';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';

// import schemas
import { concat } from 'lodash';
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import { GetTextboxValidation } from 'src/lib/validation/ValidationTypes';
const MA_P = MittelabrufSchema.attributes;

const MAEinreichen: FC<{ untertitel: string; inhalt: string }> = ({ untertitel, inhalt }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<ApplicationHeading title={untertitel} />
			<MarkdownRenderer markdown={inhalt} />

			<AbschlussSeiteHochladeFeldBox>
				<CreateForm
					formStruc={formStrucMittelAbrufHochladen()}
					formValues={application}
					updateFormValuesFunc={setApplicationProperty}
					readOnly={readOnly}
				/>
			</AbschlussSeiteHochladeFeldBox>
			<CreateForm formStruc={formStrucHinweise()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};

export default MAEinreichen;

const formStrucMittelAbrufHochladen = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ ...MA_P.Allgemein_Eingereichter_Mittelabruf, hideLabel: true }],
			userProps: { columnToDivide: 1 },
		},
	];

	return struc;
};

const formStrucHinweise = () => {
	const MAX_CHAR_LENGTH = 500;
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...MA_P.Allgemein_Hinweise_An_Die_HA,
					label: 'Mittelabruf - Ihre Nachricht an die Hessen Agentur (optional):',
					maxCharLength: MAX_CHAR_LENGTH,
					validation: [{ validateFunction: GetTextboxValidation, params: [MAX_CHAR_LENGTH], onlyValidateOnNonEmptyValue: true }],
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];

	return struc;
};

export const getFormStrucMAEinreichen = () => {
	let struc: FormStrucItem[] = [];
	struc = concat(struc, formStrucMittelAbrufHochladen(), formStrucHinweise());

	return struc;
};
